<script lang="ts" setup>
interface Props {
  active: boolean;
  message?: string;
  spinner?: boolean;
}

withDefaults(defineProps<Props>(), {
  spinner: true,
});
</script>

<template>
  <div class="position-relative">
    <slot />
    <Transition name="blockui-fade">
      <div v-if="active" class="blockui-overlay d-flex justify-content-center align-items-center">
        <div class="text-center p-4">
          <div v-if="spinner" class="spinner-border text-white mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div v-if="message" class="text-white">{{ message }}</div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.blockui-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  backdrop-filter: blur(1px);
  border-radius: inherit;
}

.blockui-fade-enter-active,
.blockui-fade-leave-active {
  transition: opacity 0.15s ease;
}

.blockui-fade-enter-from,
.blockui-fade-leave-to {
  opacity: 0;
}
</style>
